const DEFAULT_ADI_CHANNEL = '9bf7ba3816de4423963e7d6e23c072e0';
export const isDefaultADIChannel = channelId => channelId === DEFAULT_ADI_CHANNEL;
//# sourceMappingURL=is-default-adi-channel.js.map